<!--<div>
    
</div>-->
<div class="container">
    <pdf-viewer 
        [src]="data.url" 
        [render-text]="true"
        [original-size]="true"
        ></pdf-viewer>
</div>


<!--<ngx-extended-pdf-viewer 
    [src]="data.url" 
    [height]="'95%'" 
    [useBrowserLocale]="true" >
</ngx-extended-pdf-viewer>--->
